import { SurveyorAssignment } from '../types/survey';

export type SurveyorAssignmentByUid = {
  [uid: string]: SurveyorAssignment;
};

export function getAdditionalSurveyorEntries({
  surveyors,
  mainSurveyorId,
}: {
  surveyors?: SurveyorAssignmentByUid;
  mainSurveyorId?: string;
}) {
  return Object.entries(surveyors || {}).filter(
    ([uid]) => uid !== mainSurveyorId,
  );
}

export function getAdditionalSurveyorNames({
  surveyors,
  mainSurveyorId,
}: {
  surveyors?: SurveyorAssignmentByUid;
  mainSurveyorId?: string;
}) {
  return getAdditionalSurveyorEntries({ surveyors, mainSurveyorId })
    .map(([, surveyor]) => surveyor.name)
    .filter(Boolean);
}

export function getSurveyorSearchText({
  surveyorName,
  surveyors,
  mainSurveyorId,
  includeAdditionalSurveyors,
}: {
  surveyorName?: string;
  surveyors?: SurveyorAssignmentByUid;
  mainSurveyorId?: string;
  includeAdditionalSurveyors: boolean;
}) {
  const additionalSurveyorNames = includeAdditionalSurveyors
    ? getAdditionalSurveyorNames({ surveyors, mainSurveyorId })
    : [];

  return `${surveyorName || ''} ${additionalSurveyorNames.join(' ')}`
    .trim()
    .toLowerCase();
}
